/** Explicit stage / risk / rating maps — no dynamic Tailwind class generation. */

export const STAGE_LABELS = {
  new_lead: 'New Lead',
  stage_1_vetting: 'Stage 1 Vetting',
  ic_review: 'IC Review',
  fee_quotation: 'Fee & Quotation',
  stage_2_dd: 'Stage 2 Due Diligence',
  contracting: 'Contracting & Controls',
  team_lead_qc: 'Team Lead QC',
  capital_allocation: 'Capital Allocation',
  finance_handover: 'Finance Handover',
  supplier_payment: 'Supplier Payment',
  delivery_monitoring: 'Delivery & Project Monitoring',
  repayment_monitoring: 'Repayment Monitoring',
  reconciliation: 'Reconciliation & Close-Out',
  closed: 'Closed',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
};

export const STAGE_BADGE = {
  new_lead: 'neutral',
  stage_1_vetting: 'info',
  ic_review: 'warn',
  fee_quotation: 'info',
  stage_2_dd: 'info',
  contracting: 'info',
  team_lead_qc: 'warn',
  capital_allocation: 'warn',
  finance_handover: 'warn',
  supplier_payment: 'warn',
  delivery_monitoring: 'info',
  repayment_monitoring: 'info',
  reconciliation: 'info',
  closed: 'active',
  rejected: 'danger',
  withdrawn: 'neutral',
};

export const STAGE_STYLE = {
  new_lead: { bg: 'var(--surface3)', color: 'var(--text2)' },
  stage_1_vetting: { bg: 'var(--info-bg)', color: 'var(--info)' },
  ic_review: { bg: 'var(--warning-bg)', color: 'var(--warning)' },
  fee_quotation: { bg: 'var(--info-bg)', color: 'var(--info)' },
  stage_2_dd: { bg: 'var(--brand-light)', color: 'var(--brand-dark)' },
  contracting: { bg: 'var(--brand-light)', color: 'var(--brand-dark)' },
  team_lead_qc: { bg: 'var(--warning-bg)', color: 'var(--warning)' },
  capital_allocation: { bg: 'var(--accent-light)', color: 'var(--accent-dark)' },
  finance_handover: { bg: 'var(--warning-bg)', color: 'var(--warning)' },
  supplier_payment: { bg: 'var(--accent-light)', color: 'var(--accent-dark)' },
  delivery_monitoring: { bg: 'var(--brand-light)', color: 'var(--brand)' },
  repayment_monitoring: { bg: 'var(--info-bg)', color: 'var(--info)' },
  reconciliation: { bg: 'var(--brand-xlight)', color: 'var(--brand-dark)' },
  closed: { bg: 'var(--success-bg)', color: 'var(--success)' },
  rejected: { bg: 'var(--danger-bg)', color: 'var(--danger)' },
  withdrawn: { bg: 'var(--surface3)', color: 'var(--text3)' },
};

export const RISK_BADGE = {
  healthy: 'active',
  watch: 'info',
  medium: 'warn',
  high: 'danger',
  critical: 'danger',
  low: 'active',
};

export const RISK_STYLE = {
  healthy: { bg: 'var(--success-bg)', color: 'var(--success)' },
  watch: { bg: 'var(--info-bg)', color: 'var(--info)' },
  medium: { bg: 'var(--warning-bg)', color: 'var(--warning)' },
  high: { bg: 'var(--danger-bg)', color: 'var(--danger)' },
  critical: { bg: 'var(--danger-bg)', color: 'var(--danger)' },
};

export const RATING_BADGE = {
  green: 'active',
  amber: 'warn',
  red: 'danger',
  not_classified: 'neutral',
};

export const RATING_STYLE = {
  green: { bg: 'var(--success-bg)', color: 'var(--success)' },
  amber: { bg: 'var(--warning-bg)', color: 'var(--warning)' },
  red: { bg: 'var(--danger-bg)', color: 'var(--danger)' },
  not_classified: { bg: 'var(--surface3)', color: 'var(--text3)' },
};

export const PIPELINE_KANBAN_STAGES = [
  'new_lead',
  'stage_1_vetting',
  'ic_review',
  'fee_quotation',
  'stage_2_dd',
  'contracting',
  'team_lead_qc',
  'capital_allocation',
  'finance_handover',
  'supplier_payment',
  'delivery_monitoring',
  'repayment_monitoring',
  'reconciliation',
];

export const LEAD_SOURCES = [
  'Referral',
  'Existing client',
  'Website enquiry',
  'LinkedIn',
  'Cold outreach',
  'Walk-in',
  'Partner / broker',
  'Event / conference',
  'Other',
];

export const PROJECT_NATURES = [
  'Simple supply and delivery',
  'Supply, delivery and installation',
  'Service',
  'Light construction',
  'Heavy construction',
];

export const DETAIL_TABS = [
  'Overview',
  'Stage 1',
  'IC',
  'Fee',
  'Stage 2 DD',
  'Contracting',
  'Team Lead QC',
  'Capital Allocation',
  'Finance',
  'Delivery',
  'Repayment',
  'Close-Out',
  'Updates',
  'Activity Log',
];

export const TAB_TO_STAGE = {
  Overview: null,
  'Stage 1': 'stage_1_vetting',
  IC: 'ic_review',
  Fee: 'fee_quotation',
  'Stage 2 DD': 'stage_2_dd',
  Contracting: 'contracting',
  'Team Lead QC': 'team_lead_qc',
  'Capital Allocation': 'capital_allocation',
  Finance: 'finance_handover',
  Delivery: 'delivery_monitoring',
  Repayment: 'repayment_monitoring',
  'Close-Out': 'reconciliation',
  Updates: null,
  'Activity Log': null,
};

export const PAYMENT_CHECKLIST_LABELS = [
  'Bank confirmation letter uploaded and not older than 3 months',
  'Account verified by FNB system',
  'Account number matches the bank confirmation letter',
  'Account number matches the supplier quotation',
  'Quotation used has HuhslCap billing details',
];

export const TL_QC_LABELS = [
  'Overview information complete',
  'Service type correct',
  'Capital or advance amount correct',
  'Margin or advance calculation correct',
  'Invoice acceptance complete where applicable',
  'Stage 1 rejection rules completed',
  'End-client rating completed',
  'Directors and representatives screened',
  'IC votes complete',
  'IC conditions recorded',
  'IC conditions cleared where required',
  'Stage 2 documents complete',
  'PO or invoice validation complete',
  'Supplier verification complete',
  'Reissued supplier quotation received',
  'Credit report reviewed',
  'Fraud report reviewed',
  'CIPC, FICA and CSD requirements complete',
  'Signed contract uploaded',
  'Bank-control requirements complete',
  'CSD and CIPC evidence uploaded',
  'Supplier bank confirmation valid',
  'Client updates completed',
  'All gaps and exceptions commented on',
  'Deal ready for capital allocation and finance',
];

export const RECON_LABELS = [
  'Capital deployed reconciles',
  'Supplier payment matches approved amount',
  'Supplier POP available',
  'Supplier tax invoice available',
  'Supplier invoice processed in Xero',
  'Client invoice processed in Xero',
  'Delivery note available',
  'Delivery confirmed',
  'Repayment receipts available',
  'Receipt amounts match bank records',
  'Capital fully recovered',
  'HuhslCap fee fully recovered',
  'Admin fee recovered',
  'Penalties recovered where applicable',
  'Partial repayments resolved',
  'Outstanding balance is zero',
  'All receipts matched in Xero',
  'Capital returned to correct investor or pool',
  'Profit recorded',
  'Variances explained',
];

export const STAGE1_REJECTION_RULES = [
  { key: 'capital_below_150k', label: 'Capital required is below R150,000' },
  { key: 'black_ownership_below_51', label: 'Company is less than 51% black owned' },
  { key: 'import_export', label: 'Project is import or export related' },
  { key: 'heavy_construction', label: 'Project is heavy construction' },
  { key: 'logistics_transport', label: 'Project is logistics / transportation related' },
  { key: 'chrome_production', label: 'Project is chrome production related' },
  { key: 'subcontracting', label: 'Project is subcontracting' },
  { key: 'quote_mismatch', label: 'Supplier quotation does not match PO materials or specification' },
  { key: 'scam_po', label: 'Scam PO or suspected fraudulent document' },
  { key: 'adverse_fraud', label: 'Adverse fraud finding, if already known' },
  { key: 'blacklisted_director', label: 'Blacklisted director or representative' },
  { key: 'red_end_client', label: 'Red-rated end-client' },
];

export const DELIVERY_STAGES = [
  { key: 'not_started', label: 'Not started' },
  { key: 'po_issued', label: 'PO issued' },
  { key: 'supplier_confirmed', label: 'Supplier confirmed' },
  { key: 'in_production', label: 'In production' },
  { key: 'ready_for_delivery', label: 'Ready for delivery' },
  { key: 'in_transit', label: 'In transit' },
  { key: 'delivered', label: 'Delivered' },
  { key: 'completed', label: 'Completed' },
];

export const REPAYMENT_JOURNEY = [
  { key: 'pending', label: 'Awaiting repayment' },
  { key: 'partial', label: 'Partial received' },
  { key: 'paid', label: 'Fully repaid' },
  { key: 'overdue', label: 'Overdue' },
  { key: 'disputed', label: 'Disputed' },
];
